// Voice profiles that stay FREE for everyone (matches backend
// FREE_VOICE_PROFILES) — the house defaults for read-aloud pills,
// the iOS fallback, and the unlocked picks in Settings → Voice.
export const FREE_HD_PROFILES = new Set(["preacher_warm", "brother_warm"]);

// Returns the user's currently-chosen TTS voice profile key, or a
// sensible default. Read from localStorage so every Read-Aloud button
// across the app (Bible reader, Today banner, devotional cards,
// pioneer of the day, etc.) honors the same picker the user already
// configured in Settings → Voice.
//
// Previously every call site hard-coded `voice: "coral"`, which is a
// raw OpenAI voice id (not a profile). That meant "Church Grandma",
// "Civil Rights Preacher", "Mother of the Church" etc. all sounded
// identical — because the FX preset attached to each profile (which
// is what ACTUALLY differentiates them) was never being applied: the
// server only applies FX when it sees a profile key.
//
// Storage keys are owned by AudioContext.jsx; we just read them.
export function getActiveHdVoice() {
  try {
    const v = window.localStorage.getItem("hw:audio:hdVoice");
    if (v && v.trim()) {
      // Whitelist of valid voice profile keys + raw OpenAI voice IDs.
      // Anyone carrying an old localStorage pick (e.g. "kids_mickey",
      // "preacher_dream") that doesn't exist anymore will fall through
      // and reset to the default below. Includes the 5 named profiles
      // (preacher_warm, brother_warm, kids_friendly, kids_squeaky,
      // kids_hero) and the 9 raw OpenAI voices the picker also surfaces.
      const VALID = new Set([
        "preacher_warm", "brother_warm",
        "kids_friendly", "kids_squeaky", "kids_hero",
        "nova", "shimmer", "coral", "sage", "alloy", "echo", "ash", "fable", "onyx",
      ]);
      if (VALID.has(v.trim())) return v.trim();
      try { window.localStorage.removeItem("hw:audio:hdVoice"); } catch (_) {}
    }
  } catch (_) {}
  // Sensible default (owner pick, June 2026): "Warm Brother" — deep,
  // soulful delivery — is the house voice for every read-aloud pill.
  return "brother_warm";
}
